<div class="parameter-page">
  <div class="page-heading">
    <div class="heading-icon"><i class="fas fa-sliders-h"></i></div>
    <div>
      <h4 class="title">{{ 'TITLE.PARAMETER-TABLE' | translate }}</h4>
      <p>{{ 'PARAMETER_BOARD.SUBTITLE' | translate }}</p>
    </div>
  </div>

  <section class="context-card" [attr.aria-label]="'LABEL.ENTERPRISE' | translate">
    <div class="context-fields">
      <div class="field" *ngIf="hasRole(ROLE_SUPERADMIN)">
        <label for="parameter-partner">{{ 'LABEL.PARTNER' | translate }}</label>
        <div class="select-wrap">
          <i class="fa fa-university"></i>
          <select id="parameter-partner" class="form-control" [(ngModel)]="genericHead.partnerId"
                  (ngModelChange)="reloadEnterprises()" [disabled]="loading || pendingCount > 0">
            <option *ngFor="let partner of partners" [ngValue]="partner.id">{{partner.name}}</option>
          </select>
        </div>
      </div>
      <div class="field">
        <label for="parameter-enterprise">{{ 'LABEL.ENTERPRISE' | translate }}</label>
        <div class="select-wrap">
          <i class="fa fa-building"></i>
          <select id="parameter-enterprise" class="form-control" [(ngModel)]="genericHead.enterpriseId"
                  (ngModelChange)="loadAssignedParams()" [disabled]="loading || !enterprises.length || pendingCount > 0">
            <option *ngFor="let enterprise of enterprises" [ngValue]="enterprise.id">{{enterprise.name}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="context-summary" *ngIf="genericHead.enterpriseId">
      <span class="summary-label">{{ 'PARAMETER_BOARD.CONFIGURATION' | translate }}</span>
      <strong>{{enterpriseName}}</strong>
      <span class="summary-count">{{assignedCount}} {{ 'PARAMETER_BOARD.ASSIGNED' | translate }}</span>
      <small *ngIf="pendingCount" class="switch-hint">{{ 'PARAMETER_BOARD.SWITCH_HINT' | translate }}</small>
    </div>
  </section>

  <section class="board-card" *ngIf="genericHead.enterpriseId">
    <div class="board-toolbar">
      <div class="board-title">
        <h5>{{ 'PARAMETER_BOARD.PARAMETERS' | translate }}</h5>
        <span>{{parameters.length}} {{ 'PARAMETER_BOARD.AVAILABLE' | translate }}</span>
      </div>
      <div class="board-controls">
        <div class="search-wrap">
          <i class="fa fa-search"></i>
          <input class="form-control" type="search" [(ngModel)]="searchTerm"
                 [placeholder]="'PARAMETER_BOARD.SEARCH' | translate"
                 [attr.aria-label]="'PARAMETER_BOARD.SEARCH' | translate">
        </div>
        <div class="view-toggle" role="group" [attr.aria-label]="'PARAMETER_BOARD.FILTER' | translate">
          <button type="button" [class.selected]="!onlyAssigned" (click)="onlyAssigned = false">
            {{ 'PARAMETER_BOARD.ALL' | translate }}
          </button>
          <button type="button" [class.selected]="onlyAssigned" (click)="onlyAssigned = true">
            {{ 'PARAMETER_BOARD.ASSIGNED_FILTER' | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="parameter-table-wrap">
      <table class="parameter-table">
        <thead>
        <tr>
          <th>{{ 'PARAMETER_BOARD.STATUS' | translate }}</th>
          <th>{{ 'PARAMETER_BOARD.PARAMETER' | translate }}</th>
          <th>{{ 'PARAMETER_BOARD.DEFAULT_VALUE' | translate }}</th>
          <th>{{ 'PARAMETER_BOARD.COMPANY_VALUE' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let parameter of visibleParameters" [class.row-active]="isAssigned(parameter)">
          <td [attr.data-label]="'PARAMETER_BOARD.STATUS' | translate">
            <label class="assignment-switch">
              <input type="checkbox" [checked]="isAssigned(parameter)"
                     (change)="toggleAssignment($event, parameter)" [disabled]="loading"
                     [attr.aria-label]="parameter.key">
              <span class="switch-track"></span>
              <span class="switch-text">{{ (isAssigned(parameter) ? 'PARAMETER_BOARD.ENABLED' : 'PARAMETER_BOARD.DISABLED') | translate }}</span>
            </label>
          </td>
          <td [attr.data-label]="'PARAMETER_BOARD.PARAMETER' | translate">
            <strong class="parameter-key">{{parameter.key}}</strong>
            <span class="parameter-description">{{parameter.description}}</span>
          </td>
          <td [attr.data-label]="'PARAMETER_BOARD.DEFAULT_VALUE' | translate"><span class="catalog-value">{{parameter.value || '—'}}</span></td>
          <td [attr.data-label]="'PARAMETER_BOARD.COMPANY_VALUE' | translate">
            <ng-container *ngIf="isAssigned(parameter); else noValue">
              <input class="form-control company-value" type="text" maxlength="64"
                     [ngModel]="getAssignment(parameter).actualValue"
                     (ngModelChange)="setActualValue(parameter, $event)"
                     [placeholder]="'PARAMETER_BOARD.VALUE_PLACEHOLDER' | translate"
                     [attr.aria-label]="('PARAMETER_BOARD.COMPANY_VALUE' | translate) + ': ' + parameter.key"
                     [disabled]="loading">
              <small *ngIf="parameter.key === reviewerKey">{{ 'PARAMETER_BOARD.REVIEWER_HELP' | translate }}</small>
            </ng-container>
            <ng-template #noValue><span class="not-assigned">{{ 'PARAMETER_BOARD.NOT_ASSIGNED' | translate }}</span></ng-template>
          </td>
        </tr>
        <tr *ngIf="!visibleParameters.length">
          <td colspan="4" class="empty-state"><i class="far fa-folder-open"></i> {{ 'PARAMETER_BOARD.NO_RESULTS' | translate }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="board-footer">
      <div class="pending" [class.has-pending]="pendingCount > 0">
        <i class="fas fa-circle"></i>
        {{pendingCount ? pendingCount + ' ' + ('PARAMETER_BOARD.PENDING' | translate) : ('PARAMETER_BOARD.UP_TO_DATE' | translate)}}
      </div>
      <div class="footer-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="resetChanges()" [disabled]="loading || !pendingCount">
          <i class="fas fa-undo"></i> {{ 'PARAMETER_BOARD.RESET' | translate }}
        </button>
        <button type="button" class="btn btn-success" (click)="save()" [disabled]="loading || !pendingCount">
          <i class="far fa-save"></i> {{ 'BUTTON.SAVE' | translate }}
        </button>
      </div>
    </div>
  </section>

  <button type="button" class="back-link" (click)="cancel()">
    <i class="fas fa-arrow-left"></i> {{ 'PARAMETER_BOARD.BACK' | translate }}
  </button>
</div>
<app-loading *ngIf="loading"></app-loading>
